module.exports = __webpack_public_path__ + "static/media/VR.fea3cf22.pdf";